module.exports = __webpack_public_path__ + "8aad5d0675d8bcb1928f81d47a58e4c4.svg";